import { DialogContent, IconButton } from "@material-ui/core";
import ListIcon from '@material-ui/icons/List';
import { Dialog } from "@mui/material";
import { useState } from "react";
import ServicesTable from "./ServicesTable";

const ServiceListDialog = ({ activities, title, customColumns }) => {

    const [showList, setShowList] = useState(false);

    return (
        <>
            <IconButton size="small" onClick={() => setShowList(true)}><ListIcon /></IconButton>
            <Dialog maxWidth='xl' fullWidth open={showList} onClose={() => setShowList(false)}>
                <DialogContent>
                    <ServicesTable activities={activities} title={title} customColumns={customColumns}/>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default ServiceListDialog;